// extracted by mini-css-extract-plugin
export var container = "Main-module--container--MVu1C";
export var wrapper = "Main-module--wrapper--Qu8EV";